import { IObservable, Observable } from "thrive-observable-react";

//interfaces
import { SignUpStepRoutes, SignUpSteps } from "../../interfaces/Navigation";
import { IContentTile } from "thrive-components";

//services
import { navigateTo } from "../../services/navigation.service";
import { SUACService } from "../../services/SignUpAppConfig.service";

//get default data
import { getDefaultContent } from "../../api/selfSignUp";



class GetStartedModel {
    public title: string = 'Create your Thrive app';
    public subtitle: string = 'We’ll set up a fully working demo app tailored to your company. It takes 2 minutes, and there’s no payment required.';
    public information: string = 'Free 30-day trial · No credit card needed';
    public button: string = "Get started"
    public appTitle: string = "Welcome! 🎊";
    public defaultContent: IObservable<IContentTile[]> = Observable([]);

    public async getStarted() {
        SUACService.setColour("203554");

        const res = await getDefaultContent()
        .catch(err => {
            console.error(err);
        });
            
        if(res?.data) {
            SUACService.updateContentTiles(res.data.content);
        }
    }

    public onButtonClick() {
        SUACService.setCurrentStep(SignUpSteps.DETAILS);
        navigateTo(SignUpStepRoutes[SignUpSteps.DETAILS])
    }
}


export { GetStartedModel };